import React from 'react';
import {
    TextField,
    InputAdornment,
    TextFieldProps,
    styled,
} from '@mui/material';
import theme from "../../theme/theme";

const StyledTextField = styled((props: TextFieldProps) => (
    <TextField {...props} variant="outlined" fullWidth multiline />
))(() => ({
    backgroundColor: theme.palette.custom.customWhite,
    borderRadius: '30px',
    '& .MuiOutlinedInput-root': {
        cursor: 'default',
        borderRadius: '30px',
        '& fieldset': {
            borderColor: theme.palette.custom.customLightGray,
            borderWidth: '1px',
        },
        '&:hover fieldset': {
            borderColor: theme.palette.custom.customLightGray,
            borderWidth: '1px',
        },
        '&.Mui-focused fieldset': {
            borderColor: theme.palette.custom.customLightGray,
            borderWidth: '1px',
        },
        '& .MuiInputBase-input[readonly]': {
            cursor: 'default',
        },
    },
}));

type TextFieldChatProps = TextFieldProps & {
    startIcon?: React.ReactNode;
    endButton?: React.ReactNode;
    placeholder?: string;
    onEnterPress?: () => void;
    readOnly?: boolean;
};

export const TextFieldChat: React.FC<TextFieldChatProps> = (
    {
        startIcon,
        endButton,
        placeholder,
        onKeyDown,
        onEnterPress,
        readOnly,
        ...rest
    }) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            onEnterPress?.();
        }
        onKeyDown?.(e); // Weiterreichen, falls zusätzlich gebraucht
    };
    return (
        <StyledTextField
            placeholder={placeholder}
            onKeyDown={handleKeyDown}
            slotProps={{
                input: {
                    readOnly,
                    startAdornment: startIcon ? (
                        <InputAdornment position="start">{startIcon}</InputAdornment>
                    ) : undefined,
                    endAdornment: endButton ? (
                        <InputAdornment position="end">{endButton}</InputAdornment>
                    ) : undefined,
                },
            }}
            {...rest}
        />
    );
};